const ArrowDownHeavy = ({
  ...props
}: React.SVGAttributes<SVGElement>): JSX.Element => (
  <svg
    height='0.8em'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 12 13'
    {...props}
  >
    <path stroke='currentColor' strokeWidth='2' d='M6 11V0' />
    <path
      d='m6 11-.707.707.707.707.707-.707L6 11Zm.707-.707-5-5L.293 6.707l5 5 1.414-1.414Zm3.586-5-5 5 1.414 1.414 5-5-1.414-1.414Z'
      fill='currentColor'
    />
  </svg>
)

export default ArrowDownHeavy
